import { createContext, useContext } from 'react';
import type { AlertColor } from '@mui/material';

export type ToastSeverity = Extract<
  AlertColor,
  'success' | 'error' | 'info' | 'warning'
>;

export type ShowToastOptions = {
  message: string;
  severity?: ToastSeverity;
};

export type ToastContextValue = {
  showToast: (options: ShowToastOptions) => void;
};

export const ToastContext = createContext<ToastContextValue | undefined>(
  undefined,
);

export const useToast = (): ToastContextValue => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};
